// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import { createRoot } from 'react-dom/client';
import {
    Divider,
    Fab,
    Tooltip,
    IconButton,
    FormControlLabel,
    Checkbox,
    Autocomplete,
    Paper,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../../components/ToastProvider';
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import Summary from '../../../../components/acc/kalkulasi-wo/Summary';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const { showToast, hideToast } = useToast();

    const { id } = useParams();

    const [listDetail, setListDetail] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogSalesOrder, setOpenDialogSalesOrder] = useState<boolean>(false)
    const [openDialogBom, setOpenDialogBom] = useState<boolean>(false)
    const [openDialogKode, setOpenDialogKode] = useState<boolean>(false)
    const [listSalesOrder, setListSalesOrder] = useState<any[]>([])
    const [listBomVsActual, setListBomVsActual] = useState<any[]>([])
    const [editDetail, setEditDetail] = useState<boolean>(false)
    const [isInternal, setIsInternal] = useState<boolean>(false)
    const [listBom, setListBom] = useState<any[]>([])
    const [jenisOptions, setJenisOptions] = useState<any[]>([])
    const [barangOptions, setBarangOptions] = useState<any[]>([])
    const [valJenisBarang, setValJenisBarang] = useState<any>(null)
    const [valBarang, setValBarang] = useState<any>(null)
    const [isGenerateQuantifier, setIsGenerateQuantifier] = useState<boolean>(false)
    const [tabs, setTabs] = useState<string>("0")

    useEffect(() => {
        getData()
        getDetail()
        getListBom()
        getBomVsActual()
        fetchCombo('/mm/jenis-barang/list-combo', setJenisOptions)
    }, [])


    const fetchCombo = (endpoint: string, setter: (data: any[]) => void) => {
        axios
            .get(apiUrl.apiUrl + endpoint, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success) setter(res.data.data)
            })
    }
    const getListSalesOrder = (productId: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/list-open-sales-order'
        axios
            .get(url, {
                params: { sdproduct_id: productId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSalesOrder(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getBomVsActual = () => {
        const url = apiUrl.apiUrl + '/production/work-order/bom-vs-actual/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBomVsActual(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    // Komponen kecil untuk 1 item informasi
    const InfoItem = ({ label, value }: { label: string; value: string | number }) => (
        <Box sx={{ mb: 1.5 }}>
            <Typography
                sx={{ fontSize: 13, fontWeight: 600, color: "text.secondary", mb: 0.3 }}
            >
                {label}
            </Typography>
            <Typography>
                {value || "-"}
            </Typography>
        </Box>
    );

    const rowClickSalesOrder = (e: any) => {
        const data = e.data
        setOpenDialog(false)
        setOpenDialogSalesOrder(true)
        setValue('sdsoDId', data.id)
        setValue('namaCustomerDetail', data.nama_customer)
        setValue('namaProductDetail', data.nama)
        setValue('kodeProductDetail', data.kode)
        setValue('keteranganSoDetail', data.keterangan_so)
        setValue('qtyDetail', data.qty)
        setValue('keteranganDetail', data.keterangan)
        setEditDetail(false)
    }

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/production/work-order/detail-item/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListDetail(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }
    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
    }

    const getData = () => {
        const url = apiUrl.apiUrl + '/production/work-order/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('qty', data.qty)
                    setValue('product', data.product)
                    setValue('sdproduct_id', data.sdproduct_id)
                    setValue('barang', data.barang)
                    setValue('mmbarang_id', data.mmbarang_id)
                    setValue('dokumen', data.dokumen)
                    setValue('jenis', data.jenis)
                    setValue('notes', data.notes)
                    setValue('satuan', data.satuan)
                    setValue('tgl', data.tgl.replace(' ', 'T').substring(0, 16))
                    setValue('wo_proses_id', data.wo_proses_id)
                    setValue('proses', data.proses)
                    setValue('site', data.site)
                    setValue('kode', data.kode)
                    setValue('designer', data.designer)
                    getListSalesOrder(data.sdproduct_id)
                    setIsGenerateQuantifier(data.is_generate_quantifier)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const resetDetail = () => {
        setValue('qtyDetail', null)
        setValue('keteranganDetail', null)
        setValue('sdsoDId', null)
        setValue('namaCustomerDetail', null)
        setValue('namaProductDetail', null)
        setValue('keteranganSoDetail', null)
        setValue('kodeProductDetail', null)
        setValue('woOrderDId', null)
        setValue('mmjenis_barang_id', null)
        setValue('mmbarang_id', null)
        setValue('wo_order_bom_id', null)
    }

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        tgl: any,
        jenis: any,
        qty: any,
        notes: any,
        keterangan: any,
        qtyDetail: any,
        keteranganDetail: any,
        sdsoDId: any,
        namaCustomerDetail: any,
        namaProductDetail: any,
        kodeProductDetail: any,
        keteranganSoDetail: any,
        woOrderDId: any,
        product: any,
        barang: any,
        mmbarang_id: any,
        dokumen: any,
        sdproduct_id: any,
        satuan: any,
        wo_proses_id: any,
        proses: any,
        mmjenis_barang_id: any,
        wo_order_bom_id: any,
        site: any,
        kode: any,
        designer: any,
    }

    const defaultValues = {
        syscabang_id: cabang,
        sdproduct_id: null,
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Edit Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    resetDetail();
                    setOpenDialogSalesOrder(true);
                    setValue('woOrderDId', row.id);
                    setValue('namaCustomerDetail', row.nama_customer);
                    setValue('namaProductDetail', row.nama_product);
                    setValue('kodeProductDetail', row.kode_product);
                    setValue('keteranganSoDetail', row.keterangan_so);
                    setValue('qtyDetail', row.qty);
                    setValue('keteranganDetail', row.notes);
                    setEditDetail(true);
                }
            },
            {
                title: "Hapus Work Order",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleAutoCompleteJenisBarang = async (event: SyntheticEvent, newValue: any | null) => {
        let barangList = await getListCombo(newValue?.id);
        setBarangOptions(barangList);
        setValJenisBarang(newValue);
        setValue('mmjenis_barang_id', newValue?.id);
        setValue('mmbarang_id', null);
    }

    const handleAutoCompleteBarang = async (event: SyntheticEvent, newValue: any | null) => {
        setValBarang(newValue);
        setValue('mmbarang_id', newValue?.id);
    }

    const ActionButtonsBom = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Edit Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    console.log("edit BOM", row);
                }
            },
            {
                title: "Hapus BOM",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/delete-work-order-d/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    getDetail()
                    getData()
                    showToast(response.data.message, 'success');
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };
    const handleDeleteBom = (row: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/delete-bom/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getListBom()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const actionDataBom = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsBom
                    row={row}
                    onDelete={handleDeleteBom}
                />
            ),
        },
    ];

    const getListBom = () => {
        const url = apiUrl.apiUrl + '/production/work-order/list-bom/' + id
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListBom(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getListCombo = async (jenis: any) => {
        const url = apiUrl.apiUrl + '/production/work-order/list-barang-by-jenis/' + jenis
        try {
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })
            if (response.data.success) {
                return response.data.data;
            } else {
                showToast(response.data.message, 'error');
                return [];
            }
        } catch (error: any) {
            showToast(error.message, 'error');
            return [];
        }
    }
    const handlePilihBarang = async (row: any) => {
        let option = await getListCombo(row.jenis_barang_id)
        Swal.fire({
            title: 'Pilih Barang',
            html: `<div id="swal-autocomplete"></div>`,
            showCancelButton: true,
            confirmButtonText: 'Simpan',
            cancelButtonText: 'Batal',
            didOpen: () => {
                const root = createRoot(document.getElementById('swal-autocomplete')!);
                root.render(
                    <Autocomplete
                        options={option}
                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                const confirmButton = Swal.getConfirmButton();
                                if (confirmButton) {
                                    confirmButton.addEventListener('click', () => {
                                        const data = {
                                            id: row.id,
                                            mmbarang_id: newValue.id
                                        }

                                        axios.post(apiUrl.apiUrl + '/production/work-order/edit-barang-bom/' + row.id, data, {
                                            headers: { Authorization: `Bearer ${token}` }
                                        })
                                            .then(response => {
                                                if (response.data.success) {
                                                    showToast(response.data.message, 'success');
                                                    getListBom()
                                                } else {
                                                    showToast(response.data.message, 'error');
                                                }
                                            })
                                    })
                                }
                            }
                        }}
                        renderOption={(props: any, option: any) => (
                            <li {...props} key={option.id}>
                                {option.nama}
                            </li>
                        )}
                        getOptionLabel={(option: any) => option.nama}
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                label='Pilih Barang'
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                );
            }
        })
    }

    const convertComponent = [
        {
            key: "barang",
            renderCell: (row: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant='body2'>
                        {row.value || ""}
                    </Typography>
                    {row.value == null ? (
                        <IconButton
                            color="primary"
                            size="small"
                            onClick={() => { handlePilihBarang(row.data) }}
                            sx={{
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                },
                                borderRadius: 1,
                                boxShadow: 1,
                            }}
                        >
                            <Icon icon="mdi:plus" />
                        </IconButton>
                    ) : (
                        <IconButton color="primary" size="small" onClick={() => {
                            handlePilihBarang(row.data)
                        }}>
                            <Icon icon="mdi:pencil" />
                        </IconButton>
                    )}
                </Box>
            ),
        },
        {
            key: "is_kain",
            renderCell: (row: any) => {
                return (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={row.data.is_kain === 1} readOnly />}
                    />
                );
            },
        },
        {
            key: "is_jasa",
            renderCell: (row: any) => {
                return (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={row.data.is_jasa === 1} readOnly />}
                    />
                );
            },
        },
    ];

    const formatRupiah = (value) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0
        }).format(value || 0)
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Work Order
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ m: 0, mb: 3 }} />
                    <form>
                        <Grid container spacing={2} sx={{ ml: 3 }}>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Document" value={watch("dokumen")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Jenis Product" value={watch("jenis")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Product" value={watch("product")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Barang" value={watch("barang")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Qty" value={watch("qty") + " " + watch("satuan")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem
                                    label="Tanggal"
                                    value={
                                        watch("tgl")
                                            ? new Date(watch("tgl")).toLocaleDateString("id-ID", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })
                                            : "-"
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Site" value={watch("site")} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, mb: 2 }}>
                                    <InfoItem label="Kode" value={watch("kode")} />
                                    <IconButton color="primary" size="small" onClick={() => {
                                        setOpenDialogKode(true)
                                    }}>
                                        <Icon icon="mdi:pencil" />
                                    </IconButton>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Designer" value={watch("designer")} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Proses" value={watch("proses")} />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <InfoItem label="Keterangan" value={watch("notes")} />
                            </Grid>
                        </Grid>
                    </form>
                    <Divider sx={{ mt: 3 }} />
                    <Box sx={{ mt: 4 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
                            <Button variant="contained" color="primary"
                                onClick={() => {
                                    resetDetail()
                                    setEditDetail(false)
                                    setOpenDialog(true)
                                    setIsInternal(false)
                                }}>
                                Tambah Sales Order
                            </Button>
                            <Button variant="contained" color="info"
                                onClick={() => {
                                    resetDetail()
                                    setEditDetail(false)
                                    setOpenDialogSalesOrder(true)
                                    setIsInternal(true)
                                }}>
                                Tambah Internal Order
                            </Button>
                        </Box>
                        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                            LIST WORK ORDER ITEM
                        </Typography>
                        <Box sx={{ overflowX: 'auto' }}>
                            <MsiDatagrid key={1} array={listDetail} actions={actionData} />
                        </Box>
                    </Box>
                    <Divider sx={{ mt: 3 }} />
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Quantifier' />
                            <Tab value='2' label='Summary' />
                            <Tab value='1' label='BOM Vs Actual BB' />
                        </TabList>
                        <TabPanel value='0'>
                            {!isGenerateQuantifier ? (
                                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', mb: 4 }}>
                                    <Button
                                        variant="contained"
                                        color="info"
                                        startIcon={<Icon icon="mdi:auto-fix" />}
                                        onClick={() => {

                                            Swal.fire({
                                                title: 'Now loading',
                                                allowEscapeKey: false,
                                                allowOutsideClick: false,
                                                didOpen: () => {
                                                    Swal.showLoading()
                                                }
                                            })

                                            const url = apiUrl.apiUrl + '/production/work-order/generate-quantifier/' + id
                                            axios
                                                .post(url, {}, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    if (response.data.success) {
                                                        // showToast(response.data.message, 'success');

                                                        Swal.close()

                                                        location.reload();
                                                    } else {
                                                        showToast(response.data.message, 'error');
                                                    }
                                                })
                                                .catch(error => {
                                                    showToast(error.message, 'error');
                                                })


                                        }}
                                    >
                                        GENERATE QUANTIFIER
                                    </Button>
                                </Box>
                            ) :
                                <Box sx={{ mt: 4 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 2 }}>
                                        <Button
                                            variant="contained"
                                            color="info"
                                            startIcon={<Icon icon="mdi:auto-fix" />}
                                            onClick={() => {
                                                Swal.fire({
                                                    title: 'Now loading',
                                                    allowEscapeKey: false,
                                                    allowOutsideClick: false,
                                                    didOpen: () => {
                                                        Swal.showLoading()
                                                    }
                                                })

                                                const url = apiUrl.apiUrl + '/production/work-order/generate-quantifier/' + id
                                                axios
                                                    .post(url, {}, {
                                                        headers: { Authorization: `Bearer ${token}` }
                                                    })
                                                    .then(response => {
                                                        if (response.data.success) {
                                                            // showToast(response.data.message, 'success');

                                                            Swal.close()

                                                            location.reload();
                                                        } else {
                                                            showToast(response.data.message, 'error');
                                                        }
                                                    })
                                                    .catch(error => {
                                                        showToast(error.message, 'error');
                                                    })


                                            }}
                                        >
                                            GENERATE ULANG QUANTIFIER
                                        </Button>
                                        <Button variant="contained" color="warning"
                                            onClick={() => {
                                                resetDetail()
                                                setEditDetail(false)
                                                setOpenDialogBom(true)
                                            }}>
                                            Tambah BOM Item
                                        </Button>
                                    </Box>
                                    <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                                        LIST BOM WORK ORDER
                                    </Typography>
                                    <Box sx={{ overflowX: 'auto' }}>
                                        <MsiDatagrid key={1} array={listBom} actions={actionDataBom} customRender={convertComponent} hiddenColumns={['is_jasa', 'is_aktif', 'jenis_barang_id']} />
                                    </Box>
                                </Box>
                            }
                        </TabPanel>
                        <TabPanel value='1'>
                            {/* ===== SUMMARY ===== */}
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Paper elevation={2} sx={{ p: 2, minWidth: 150 }}>
                                        <Typography variant="caption" color="text.secondary">
                                            Total BOM
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold">
                                            {formatRupiah(
                                                listBomVsActual && listBomVsActual.length > 0
                                                    ? listBomVsActual[0].total_bom
                                                    : 0
                                            )}
                                        </Typography>
                                    </Paper>

                                    <Paper elevation={2} sx={{ p: 2, minWidth: 150 }}>
                                        <Typography variant="caption" color="text.secondary">
                                            Total Realisasi
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold">
                                            {formatRupiah(
                                                listBomVsActual && listBomVsActual.length > 0
                                                    ? listBomVsActual[0].total_realisasi
                                                    : 0
                                            )}
                                        </Typography>
                                    </Paper>

                                    <Paper
                                        elevation={2}
                                        sx={{
                                            p: 2,
                                            minWidth: 150,
                                            bgcolor: listBomVsActual && listBomVsActual.length > 0 && listBomVsActual[0].sisa < 0
                                                ? 'error.lighter'
                                                : 'success.lighter'
                                        }}
                                    >
                                        <Typography variant="caption" color="text.secondary">
                                            Sisa
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold">
                                            {formatRupiah(
                                                listBomVsActual && listBomVsActual.length > 0
                                                    ? listBomVsActual[0].sisa
                                                    : 0
                                            )}
                                        </Typography>
                                    </Paper>
                                </Box>
                            </Box>

                            {/* ===== DATAGRID ===== */}
                            <MsiDatagrid
                                key={1}
                                array={listBomVsActual}
                                convertNumeric={['qty_bom', 'qty_realisasi']}
                                convertRupiah={['harga', 'nilai_bom', 'nilai_realisasi']}
                                hiddenColumns={['barang_id', 'id', 'total_realisasi', 'total_bom', 'sisa']}
                            />

                        </TabPanel>
                        <TabPanel value='2'>
                            <Summary id={id} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Tambah Sales Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3}>
                        <MsiDatagrid array={listSalesOrder} rowClick={rowClickSalesOrder} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogSalesOrder}
                onClose={() => setOpenDialogSalesOrder(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = '';
                    if (editDetail) {
                        url = apiUrl.apiUrl + '/production/work-order/edit-sales-order/' + data.woOrderDId;
                    } else {
                        url = apiUrl.apiUrl + '/production/work-order/save-sales-order/' + id;
                    }

                    axios.post(url, {
                        id: editDetail ? data.woOrderDId : data.sdsoDId,
                        qty: data.qtyDetail,
                        notes: data.keteranganDetail,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, "success")
                                setOpenDialogSalesOrder(false);
                                getListSalesOrder(getValues('jenis')); // Refresh the sales order list
                                getDetail(); // Refresh the detail list
                                getData(); // Refresh the main data
                            } else {
                                showToast(response.data.message, "error")
                                setOpenDialogSalesOrder(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, "error")
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Sales Order
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    {editDetail ? <Controller
                                        name='woOrderDId'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='ID Detail'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                InputProps={{ readOnly: true }} // Make the input read-only
                                            />
                                        )}
                                    /> :
                                        !isInternal ?
                                            <Controller
                                                name='sdsoDId'
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        value={value}
                                                        label='ID SO Detail'
                                                        type='number'
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={onChange}
                                                        InputProps={{ readOnly: true }} // Make the input read-only
                                                    />
                                                )}
                                            />
                                            : null
                                    }
                                </FormControl>
                            </Grid>
                            {
                                !isInternal ?
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='namaCustomerDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Nama Customer'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='namaProductDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Nama Product'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='kodeProductDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Kode Product'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='keteranganSoDetail'
                                                    control={control}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            label='Keterangan SO'
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={onChange}
                                                            InputProps={{ readOnly: true }} // Make the input read-only
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                    :
                                    null
                            }

                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qtyDetail'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Qty'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.qtyDetail)}
                                            />
                                        )}
                                    />
                                    {errors.qtyDetail && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keteranganDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogSalesOrder(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogBom}
                onClose={() => setOpenDialogBom(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = '';
                    if (editDetail) {
                        url = apiUrl.apiUrl + '/production/work-order/edit-barang-bom/' + data.wo_order_bom_id;
                    } else {
                        url = apiUrl.apiUrl + '/production/work-order/save-bom/' + id;
                    }

                    axios.post(url, {
                        id: editDetail ? data.wo_order_bom_id : id,
                        jenis_barang_id: data.mmjenis_barang_id,
                        mmbarang_id: data.mmbarang_id,
                        qty: data.qtyDetail,
                        keterangan: data.keterangan
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogBom(false);
                                getListBom();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogBom(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Work Order BOM
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valJenisBarang}
                                        options={jenisOptions}
                                        id='mmjenis_barang_id'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleAutoCompleteJenisBarang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={(option: any) => option.nama}
                                        renderInput={(params: any) => (
                                            <TextField
                                                {...params}
                                                label='Jenis Barang'
                                                required
                                                error={Boolean(errors.mmjenis_barang_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valBarang}
                                        options={barangOptions}
                                        id='mmbarang_id'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleAutoCompleteBarang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={(option: any) => option.nama}
                                        renderInput={(params: any) => (
                                            <TextField
                                                {...params}
                                                label='Barang'
                                                required
                                                error={Boolean(errors.mmbarang_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qtyDetail'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Qty'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.qtyDetail)}
                                            />
                                        )}
                                    />
                                    {errors.qtyDetail && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                type='text'
                                                multiline
                                                rows={2}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.keterangan)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogBom(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogKode}
                onClose={() => setOpenDialogKode(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = apiUrl.apiUrl + '/production/work-order/edit-kode-wo/' + id;

                    axios.post(url, {
                        kode: data.kode
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogKode(false);
                                getData();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogKode(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Edit Kode Work Order
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.kode)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogKode(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid >
    )
}
